<!-- <template>
    <SectionContainer v-for="(item, index) in source.features" :key="index" :bg="index % 2 === 0">
        <CardBlogSection v-if="item.type === 'blog'" :source="item"></CardBlogSection>
        <CardCustomerReviews v-else-if="source.type === 'customerReviews'" :source="item"></CardCustomerReviews>
        <CardSassPricing v-else-if="item.type === 'sassPricing'"></CardSassPricing>
        <CardNearhubDemo v-else-if="item.type === 'nearhubDemo'"></CardNearhubDemo>
        <HeroFeature v-else :index="index" :source="item"> </HeroFeature>
    </SectionContainer>
</template> -->

<script lang="ts">
import SectionContainer from "@/components/Section/Container.vue";
import { componentsMap } from "./components";

// componentsMap.set("hubspotForm", () => import("@/components/Hubspot/Form.vue"));
export default defineComponent({
    props: {
        source: Object as any,
        index: Number,
    },
    setup(props, { slots }) {
        const CurrentComponent = computed(() => {
            let { type, ...reset } = props.source;
            let index = props.index;
            let result = null;
            const component = componentsMap.get(type || "heroFeature");
            result = () => h(defineAsyncComponent(component), { source: reset as any, index }, slots ?? null);

            return result;
        });
        return () => {
            const { source, index = 0 } = props;
            const Component = CurrentComponent.value;
            if (source.layout === false) {
                return h(Component);
                // return <Component></Component>;
            }
            return h(SectionContainer, { bg: index % 2 === 0, elId: source.elId }, Component);
            // return (
            //     <SectionContainer bg={index % 2 === 0}>
            //         <Component></Component>
            //     </SectionContainer>
            // );
        };
    },
});
</script>
